import { useState } from 'react';

import createPersistedState from 'use-persisted-state';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const mockElement = {
  classList: {
    add: noop,
    remove: noop,
  },
};

const preferDarkQuery = '(prefers-color-scheme: dark)';

const initialize = (storageKey: any, storageProvider: any, glbl = global) => {
  const usePersistedDarkModeState = storageKey
    ? createPersistedState(storageKey, storageProvider)
    : useState;

  const mql: any = glbl.matchMedia ? glbl.matchMedia(preferDarkQuery) : {};

  const mediaQueryEventTarget: any = {
    addEventListener: (_: any, handler: any) =>
      mql.addListener && mql.addListener(handler),
    removeEventListener: (_: any, handler: any) =>
      mql.removeListener && mql.removeListener(handler),
  };

  const isColorSchemeQuerySupported = mql.media === preferDarkQuery;

  const getInitialValue = (usersInitialState: any) =>
    isColorSchemeQuerySupported ? mql.matches : usersInitialState;

  // Mock element if SSR else real body element.
  const defaultElement = (glbl.document && glbl.document.body) || mockElement;

  const getDefaultOnChange =
    (
      element = defaultElement,
      classNameDark = 'dark-mode',
      classNameLight = 'light-mode'
    ) =>
    (val: any) => {
      element.classList.add(val ? classNameDark : classNameLight);
      element.classList.remove(val ? classNameLight : classNameDark);
    };

  return {
    usePersistedDarkModeState,
    getDefaultOnChange,
    mediaQueryEventTarget,
    getInitialValue,
  };
};

export default initialize;
